<template>
  <section>
    <template>
      <!-- モーダル画面 -->
      <div style="display: flex;">
        <!-- アラートダイアログ -->
        <ModalAlertDialog
          :isAlertDialogOpen="isAlertDialogOpen"
          :alertData="alertData"
          @alertResult="alertResult"
        />
      </div>
    </template>
    <div class="card" style="border-radius: 5px;">
      <header class="card-header">
        <p class="card-header-title title" style="font-size: 20px;">
          タグの設定
        </p>
      </header>
      <div class="card-content">
        <p v-if="isTagProgress"><span class="mdi mdi-loading mdi-spin"></span>{{this.isCreate ? '作成中です' : '削除中です'}}</p>
        <div class="taglist">
          <!-- 登録済みタグリスト -->
          <template v-if="currentTagList">
            <div class="tag is-primary is-small" style="margin-right: 5px; margin-bottom: 5px;" v-for="(tag, idx) in currentTagList" :key="idx" v-show="tag != ''">
              {{tag}}
              <span class="mdi mdi-close delete-tag-btn" style="margin-left:5px;" @click="deleteTag(tag)"></span>
            </div>
          </template>
          <!-- 新規登録タグ -->
          <div class="tag is-primary is-small" style="margin-bottom: 5px;">
            <inputTag ref="refinput"
              :isTagProgress="isTagProgress"
              :defaultTagList="defaultTagList"
              :addTagName="addTagName"
              @setClickTag="setClickTag"
              @addTag="addTag"
            />
            <button class="plus-button mdi mdi-plus mdi-24px" @click="$refs.refinput.addTag()"></button>
          </div>
          <!-- 入力タグ候補 -->
          <div v-show="isClickTag">
            <button class="tag is-small buttonCandidate"  v-for="(candidate, idx) in getCandidateTagList" :key="idx"  @click="tagCandidate(candidate)">
              {{candidate}}
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

/**
 * アラートダイアログ用定義
 */
import {
    /** アラートダイアログ用定義 */
    ALERT_DEF,
    /** アラートダイアログ用データ作成 */
    createAlertData
} from '@/functions/common/alertFunc'
import ModalAlertDialog      from '@/components/organisms/common/ModalAlertDialog'
import _                     from 'lodash'

export default {
  name: 'TemplateTagEdit',
  componentName: 'TemplateTagEdit',
  components: {
    ModalAlertDialog,
    inputTag: {
      template: `<input class="edit-taginput" placeholder="タグを設定" v-model="inputTagName" ref="tag" @focus="isClick(true)" :disabled="isTagProgress"/>`,
      props: ['isTagProgress', 'defaultTagList', 'addTagName'],
      data () {
        return {
          clickFlag   : false,
          tagTarget   : {},
          searchWords : null,
          inputTagName: ''
        }
      },
      watch: {
        addTagName () {
          this.inputTagName = this.addTagName
        }
      },
      methods: {
        isClick (clickFlag) {
          this.$emit('setClickTag', clickFlag)
        },
        addTag () {
          // タグの更新
          this.$emit('addTag', this.inputTagName)
          this.clickFlag = false
          this.inputTagName = ''
        }
      }
    }
  },
  computed: {
    getCandidateTagList () {
      const allTag =  this.defaultTagList.concat(this.currentTagList)
      return _.xor(allTag, this.currentTagList)
    }
  },
  data () {
    return {
      /** モーダルダイアログ開閉フラグ */
      isAlertDialogOpen: false,
      /** 作成/削除フラグ */
      isCreate         : false,
      /** アラートダイアログ表示データ */
      alertData        : {},
      /** タグクリック判別フラグ */
      isClickTag       : false,
      /** クリックタグID */
      isClickId        : '',
      /** 登録タグ名 */
      addTagName       : '',
    }
  },
  props: {
    /** タグ編集中フラグ */
    isTagProgress : {
      type    : Boolean,
      default : false,
      required: true
    },
    /** 親オブジェクト */
    targetObj: {
      required: false
    },
    /** デフォルトタグリスト */
    defaultTagList: {
      required: true
    },
    /** 親タグリスト */
    currentTagList: {
      required: true
    },
    /** エラーフラグ */
    isError: {
      type    : Boolean,
      default : false,
      required: false
    },
    /** エラータイトル */
    errorTitle: {
      type    : String,
      default : '',
      required: false
    },
    /** エラーメッセージ */
    errorMessage: {
      type    : String,
      default : '',
      required: false
    }
  },
  watch: {
    /** タグ編集中フラグ */
    isTagProgress () {
      if (!this.isTagProgress) {
        this.isCreate = false
      }
    },
    /** エラーフラグ */
    isError () {
      if (this.isError) {
        this.alertError (this.errorTitle, this.errorMessage)
      }
    }
  },
  methods: {
    /** タグクリック判別セット */
    setClickTag (clickFlag) {
      this.isClickTag = clickFlag
    },
    /** タグ候補セット */
    tagCandidate (candidate){
      this.addTagName = candidate
    },
    /** タグ追加 */
    addTag (addTagName){
      if (!addTagName) {
        this.alertError('新規タグの追加', 'タグ名を入力してください。')
      } else {
        this.isCreate = true
        this.$emit('addTag', this.targetObj, addTagName)
        this.addTagName = ''
        this.isClickTag = false
      }
    },
    /** タグ削除 */
    deleteTag(delTag){
      this.$emit('deleteTag', delTag)
      this.isClickTag = false
    },
    /** エラーアラート表示 */
    alertError (title, message) {
      this.alertData = createAlertData(
          title,
          message,
          ALERT_DEF.MESSAGE_WARNING,
          ALERT_DEF.DIALOG_ALERT,
          'template-tag-edit'
      )
      this.isAlertDialogOpen = true
    },
    /** アラート結果取得 */
    alertResult (result) {
      if (result.alertKeyFunction === 'template-tag-edit') {
        this.isAlertDialogOpen = false
        this.$emit('errorClear')
      }
    }
  }
}
</script>

<style scoped>
.taglist {
  width: 100%;
  margin-top: 8px;
  display: flex;
  flex-wrap: wrap;
}
.plus-button {
  background: rgba(255, 255, 255, 0.0);
  cursor: pointer;
  color: white;
  border: none;
  outline : none;
}
.edit-taginput {
  background: rgba(255,255,255, 0.00) !important;
  width: 80px;
  text-align: center;
  color: white;
  border: none;
  font-size: 12px;
}
.edit-taginput::placeholder {
  color: white;
  font-size: 12px;
}
.buttonCandidate{
  background-color: white;
  float:left;
  margin-right: 5px;
  margin-bottom: 5px;
  border:solid black 1px;
  cursor: pointer;
  cursor: hand;
}
.buttonCandidate:hover{
  color:white;
  background-color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/templates/TemplateTagEdit.vue